import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { logError } from "@/lib/log";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [state, setState] = useState("checking");
  const [info, setInfo] = useState(null);

  useEffect(() => {
    const sid = params.get("session_id");
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setInfo(data); setState("paid"); return; }
        if (["expired", "failed"].includes(data.payment_status)) { setState("failed"); return; }
      } catch (e) { logError("Payment status poll failed", e); }
      if (tries++ < 8) setTimeout(poll, 2000); else setState("failed");
    };
    if (sid) poll(); else setState("failed");
  }, [params]);

  return (
    <div className="min-h-screen bg-base grid-bg grid place-items-center px-6">
      <div className="bg-surface border border-[#CBEEF5] rounded-xl p-10 max-w-md w-full text-center fade-up">
        {state === "checking" && (<><Loader2 className="w-12 h-12 text-neon animate-spin mx-auto mb-4" /><h1 className="font-head text-xl font-bold">Confirming payment…</h1></>)}
        {state === "paid" && (<><CheckCircle2 className="w-12 h-12 text-[#39FF14] mx-auto mb-4" /><h1 className="font-head text-2xl font-bold mb-2">Payment successful</h1><p className="text-zinc-600 mb-6 font-mono text-sm">{info?.quantity} {info?.product === "isp_ip" ? "ISP IPs" : "GB"} provisioned.</p><Button onClick={() => nav("/dashboard")} className="bg-neon text-base hover:bg-neon-hover font-semibold" data-testid="payment-back-dashboard">Go to Dashboard</Button></>)}
        {state === "failed" && (<><XCircle className="w-12 h-12 text-[#FF3366] mx-auto mb-4" /><h1 className="font-head text-xl font-bold mb-2">Payment not confirmed</h1><Button onClick={() => nav("/dashboard")} variant="outline" className="border-[#CBEEF5]">Back to Dashboard</Button></>)}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-base grid-bg grid place-items-center px-6">
      <div className="bg-surface border border-[#CBEEF5] rounded-xl p-10 max-w-md w-full text-center">
        <XCircle className="w-12 h-12 text-[#FFB800] mx-auto mb-4" />
        <h1 className="font-head text-xl font-bold mb-2">Checkout cancelled</h1>
        <p className="text-zinc-600 mb-6">No charge was made.</p>
        <Button onClick={() => nav("/dashboard")} className="bg-neon text-base hover:bg-neon-hover font-semibold">Back to Dashboard</Button>
      </div>
    </div>
  );
}
